type Route = {
  path: string | RegExp;
  handler: (container: HTMLElement, params?: Record<string, string>) => void | Promise<void>;
};

class Router {
  private routes: Route[] = [];
  private container: HTMLElement | null = null;

  register(path: string | RegExp, handler: Route['handler']): void {
    this.routes.push({ path, handler });
  }

  init(container: HTMLElement): void {
    this.container = container;

    window.addEventListener('popstate', () => this.navigate(window.location.pathname, false));

    document.addEventListener('click', (e) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a');
      if (anchor && anchor.href.startsWith(window.location.origin)) {
        e.preventDefault();
        this.navigate(anchor.pathname);
      }
    });

    this.navigate(window.location.pathname, false);
  }

  navigate(path: string, pushState = true): void {
    if (!this.container) return;

    if (pushState) {
      window.history.pushState({}, '', path);
    }

    for (const route of this.routes) {
      if (typeof route.path === 'string') {
        if (route.path === path) {
          route.handler(this.container);
          return;
        }
      } else {
        const match = path.match(route.path);
        if (match) {
          const params: Record<string, string> = {};
          match.slice(1).forEach((value, index) => {
            params[`$${index + 1}`] = value;
          });
          route.handler(this.container, params);
          return;
        }
      }
    }

    // 404
    this.container.innerHTML = `
      <div class="container" style="text-align: center; padding-top: 4rem;">
        <h1>404 - Page Not Found</h1>
        <p style="color: var(--color-text-muted); margin-top: 1rem;">The page you're looking for doesn't exist.</p>
        <a href="/" style="color: var(--color-primary); display: inline-block; margin-top: 2rem;">Go Home</a>
      </div>
    `;
  }
}

export const router = new Router();

// Register routes
import { renderLanding } from './pages/landing';
import { renderDashboard } from './pages/dashboard';
import { renderEventView } from './pages/event-view';
import { renderStream } from './pages/stream';
import { renderAuthCallback } from './pages/auth-callback';

router.register('/', renderLanding);
router.register('/auth/callback', renderAuthCallback);
router.register('/dashboard', renderDashboard);
router.register(/^\/events\/([^/]+)$/, renderEventView);
router.register(/^\/stream\/([^/]+)$/, renderStream);
